import apiClient from "./ApiService"

const checkPosition = async (latitude, longitude, accuracy) => apiClient.post("/clocking/check-position", {latitude, longitude, accuracy})

const performClocking = async (latitude, longitude, accuracy) => apiClient.post("/clocking", {latitude, longitude, accuracy})

const addClocking = async (geo_out_of_range) => apiClient.post("/clocking", {geo_out_of_range})

const generateClockingQrCode = async () => apiClient.get("/clocking/qr-code")

const getClockings = async (today = false) => apiClient.get(`/clocking${today ? "?today=true" : ""}`)

const getClockingsByYearMonth = async (year, month) => apiClient.get(`/clocking?year=${year}&month=${month}`)

const getClockingsByDate = async (date) => apiClient.get(`/clocking?date=${date}`)

const getClockingPunchesByDate = async (date) => apiClient.get(`/clocking/punches?date=${date}`)

const getTimesheet = async (year, month) => apiClient.get(`/timesheet?year=${year}&month=${month}`)

const getFirstOpenTimesheet = async () => apiClient.get("employee/timesheet/first-open")

const updateTimesheet = async (date, category, n_hours, protocol_number, attachment_url = null, old_category = null) => apiClient.put("/timesheet/justify", {
  date,
  category,
  n_hours,
  protocol_number,
  attachment_url,
  old_category
})

const updateTimesheetNotes = async (date, notes) => apiClient.put("/timesheet/notes", {
  date,
  notes,
})

const closeTimesheet = async (year, month) => apiClient.post("employee/timesheet/close", {year, month})

const addExtraHoursTimesheet = async (date, category, n_hours) => apiClient.put("/timesheet/extra-hours", {
  date,
  category,
  n_hours,
})

const getNotices = async () => apiClient.get("employee/notice")

const getDocuments = async (path) => apiClient.get(`employee/documents${path ? `?path=${path}` : ''}`)

const getNotifications = async () => apiClient.get("employee/notifications")

const setNotificationsAsRead = async () => apiClient.put("employee/notifications/mark-as-read")

const addTimesheetRequest = async (request) => apiClient.post("timesheet/requests", request)

const getTimesheetRequests = async () => apiClient.get("timesheet/requests")

const getTimesheetRequestsByDate = async (date) => apiClient.get(`timesheet/requests?date=${date}`)

const getTimesheetRequestsOfToday = async () => apiClient.get(`timesheet/requests?today=true`)

const cancelTimesheetRequest = async (company_id, request_id) => apiClient.post(`company/${company_id}/timesheets/requests/${request_id}/cancel`, {})

const askCancelTimesheetRequest = async (company_id, request_id) => apiClient.post(`company/${company_id}/timesheets/requests/${request_id}/ask-cancel`, {})

const updateProfilePicture = async (id, filename) => apiClient.put("employee/profile-picture", {profile_picture: filename})

const markNoticeAsRead = async (id) => apiClient.put(`notice/${id}`)

const getNoticeAttachment = async (id) => apiClient.get(`notice/${id}/attachment`)

const createExpenseReport = async (expenseReport) => apiClient.post("employee/expense-report", expenseReport)

const getExpenseReports = async () => apiClient.get("employee/expense-report")

// Correzione di una nota respinta: salvare la re-invia in approvazione
const updateExpenseReport = async (id, expenseReport) => apiClient.put(`employee/expense-report/${id}`, expenseReport)

const deleteExpenseReport = async (id) => apiClient.delete(`employee/expense-report/${id}`)

const deleteExpenseReportAttachment = async (id, key) =>
  apiClient.delete(`employee/expense-report/${id}/attachment`, { params: { key } })

const getTimeProfile = async () => apiClient.get("employee/time-profile")

const getExpenseReportAttachments = async (expenseReportId) => apiClient.get(`employee/expense-report/${expenseReportId}/attachments`)

const updateEmployeeToken = async (token) => apiClient.put('employee/notification-token', {notification_token: token})

const updateEmployee = async (data) => apiClient.put("employee", data)

const notifyUpdate = async () => apiClient.post("employee/notify-update")

const getDatiContabili = async () => apiClient.get("employee/dati-contabili")

const getResiduiProjection = async (date) => apiClient.get(`employee/residui-projection${date ? `?date=${date}` : ''}`)

const getGuestOfToday = async () => apiClient.get("employee/guests/today")

const addGuest = async (guest) => apiClient.post("employee/guests", guest)

const updateGuest = async (id, guest) => apiClient.put(`employee/guests/${id}`, guest)

const getExternalLinks = async () => apiClient.get(`/employee/links`)

const getPopups = async () => apiClient.get("/employee/popups")

const exportTimesheetPdf = async (year, month) => apiClient.get(`/employee/timesheet/pdf?year=${year}&month=${month}`)

const getSelfApprovalCategories = async () => apiClient.get("/employee/self-approval-categories")

const getCompanyProjects = async () => apiClient.get(`/employee/projects/list`)

const getProjectsByDay = async (date) => apiClient.get(`/employee/projects?date=${date}`)

const addProjectHours = async (data) => apiClient.post("/employee/projects", data)

const updateProjectHours = async (id, data) => apiClient.put(`/employee/projects/${id}`, data)

const deleteProjectHours = async (id) => apiClient.delete(`/employee/projects/${id}`)

const selfApproveRequest = async (request_id) => apiClient.post(`/employee/request/${request_id}/self-approve`)


const getHolidayPlanningData = async (viewMode, year, month, area = null) => {
  const params = new URLSearchParams({ viewMode, year: year.toString() });
  if (month) {
    params.append('month', month.toString());
  }
  if (area) {
    params.append('area', area);
  }
  return apiClient.get(`/timesheet/holiday-planning?${params.toString()}`)
}

const getHolidayPlanObjectives = async () => apiClient.get('/employee/holiday-plan/objectives')

const getHolidayPlanMetrics = async (date) => apiClient.get(`/employee/holiday-plan/metrics?date=${date}`)
const getHolidayPlanPayslip = async (year) => apiClient.get(`/employee/holiday-plan/payslip?year=${year}`)

const getPendingDocuments = () => apiClient.get('/employee/pending-documents')

const previewPendingDocument = (id, userInput) =>
  apiClient.post(`/employee/pending-documents/${id}/preview`, { userInput }, { responseType: 'blob' })

const submitPendingDocument = (id, userInput) =>
  apiClient.post(`/employee/pending-documents/${id}/submit`, { userInput })

const getDocumentsToSign = () => apiClient.get('/employee/documents-to-sign')

const initSignatureSession = (documentId) =>
  apiClient.post('/api/v1/signatures/init', { documentId })

const executeSignature = (sessionId, otp) =>
  apiClient.post(`/api/v1/signatures/${sessionId}/sign`, { otp })

const EmployeeService = {
  checkPosition,
  performClocking,
  addClocking,
  generateClockingQrCode,
  getClockings,
  getClockingsByYearMonth,
  getTimesheet,
  getFirstOpenTimesheet,
  getClockingsByDate,
  getClockingPunchesByDate,
  updateTimesheet,
  updateTimesheetNotes,
  closeTimesheet,
  addExtraHoursTimesheet,
  getNotices,
  getDocuments,
  getNotifications,
  setNotificationsAsRead,
  addTimesheetRequest,
  getTimesheetRequests,
  getTimesheetRequestsByDate,
  getTimesheetRequestsOfToday,
  cancelTimesheetRequest,
  askCancelTimesheetRequest,
  updateProfilePicture,
  markNoticeAsRead,
  getExpenseReports,
  createExpenseReport,
  updateExpenseReport,
  deleteExpenseReport,
  deleteExpenseReportAttachment,
  getTimeProfile,
  getExpenseReportAttachments,
  updateEmployeeToken,
  updateEmployee,
  notifyUpdate,
  getDatiContabili,
  getResiduiProjection,
  getGuestOfToday,
  addGuest,
  updateGuest,
  getExternalLinks,
  getPopups,
  exportTimesheetPdf,
  getSelfApprovalCategories,
  getCompanyProjects,
  getProjectsByDay,
  addProjectHours,
  updateProjectHours,
  deleteProjectHours,
  selfApproveRequest,
  getHolidayPlanningData,
  getHolidayPlanObjectives,
  getHolidayPlanMetrics,
  getHolidayPlanPayslip,
  getPendingDocuments,
  previewPendingDocument,
  submitPendingDocument,
  getDocumentsToSign,
  initSignatureSession,
  executeSignature,
  getNoticeAttachment,
};
export default EmployeeService;
